import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// Right click on primary result user profile for who question-answer
export const onWhoPrimaryViewProfileContextMenuClick: ({
	primaryUserName,
	...props
}: commonAttributesType & {
	primaryUserName: string;
}) => AnalyticsEventPayload = ({
	primaryUserName,
	...props
}: commonAttributesType & {
	primaryUserName: string;
}): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'contextMenuClicked',
		actionSubject: 'aiAnswerWhoPrimaryViewProfile',
		source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
			primaryUserName,
		},
	};
};
